<router-outlet></router-outlet>

<app-bottom-sheet-mobile *ngIf="(isAuthenticated$ | async) && isPrivateModule"></app-bottom-sheet-mobile>

<app-stacked-snackbar-container></app-stacked-snackbar-container>